module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBBc-.87284894.woff";